export const POSITIONS = ["Torwart", "Abwehr", "Mittelfeld", "Angriff"];
export const SIZES = ["152", "164", "S", "M", "L", "XL"];

export const POSITION_ABBREV = {
  Torwart: "TW",
  Abwehr: "ABW",
  Mittelfeld: "MIT",
  Angriff: "ANG",
};

export function positionAbbrev(pos) {
  return POSITION_ABBREV[pos] || (pos || "").slice(0, 3).toUpperCase();
}

export const ATTRIBUTES = [
  { key: "passqualitaet", label: "Passqualität" },
  { key: "schnelligkeit", label: "Schnelligkeit" },
  { key: "torschuss", label: "Torschuss" },
  { key: "ballkontrolle", label: "Ballkontrolle" },
  { key: "dribbling", label: "Dribbling" },
  { key: "ausdauer", label: "Ausdauer" },
  { key: "zweikampfverhalten", label: "Zweikampfverhalten" },
  { key: "aggressivitaet", label: "Aggressivität" },
  { key: "spielintelligenz", label: "Spielintelligenz" },
  { key: "torhueter", label: "Torhüter" },
  { key: "teamfaehigkeit", label: "Teamfähigkeit" },
  { key: "trainingsdisziplin", label: "Trainingsdisziplin" },
];

export const ATTRIBUTE_KEYS = ATTRIBUTES.map((a) => a.key);

export function defaultAttributes() {
  return ATTRIBUTE_KEYS.reduce((acc, k) => {
    acc[k] = 5;
    return acc;
  }, {});
}

export function computeOverall(attrs) {
  const vals = ATTRIBUTE_KEYS.map((k) => Number(attrs[k] || 0));
  const sum = vals.reduce((a, b) => a + b, 0);
  return Math.round((sum / vals.length) * 10) / 10;
}

export function positionColor(pos) {
  switch (pos) {
    case "Torwart":
      return "text-amber-400";
    case "Abwehr":
      return "text-sky-400";
    case "Mittelfeld":
      return "text-emerald-400";
    case "Angriff":
      return "text-rose-400";
    default:
      return "text-zinc-400";
  }
}

// Standardisierte alphabetische Sortierung nach Spielername (de-Locale, case-insensitive)
// Wird projektweit für alle Spielerauswahlen verwendet.
export function sortPlayersByName(players) {
  return [...players].sort((a, b) =>
    (a?.name || "").localeCompare(b?.name || "", "de", { sensitivity: "base" })
  );
}

export function formatDateDE(iso) {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
}
